<template>
    <div>
        <pardakhtShakhsi-filter :action="filterAction" ></pardakhtShakhsi-filter>
        <kt-datatable  v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
</template>

<script>
    import { ApiUrl } from '@/common/api.service'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import columns from './../datatable/columns'
    import actionsColumn from './actions-column'
    import pardakhtShakhsiFilter from './pardakht-shakhsi-filter'

    export default {
        components: {
            'pardakhtShakhsi-filter': pardakhtShakhsiFilter,
        },
        data() {
            return {
                query: {}
            }
        },
        computed: {
            datatableProps() {
                return {
                    id: "pardakht_shakhsi_datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path('pardakht-shakhsi'),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: function(res) {
                                    return res.data.data
                                },
                                params: {
                                    query: this.query
                                },
                            },
                        },

                        pageSize: 10,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    layout: {
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,
                    actions: actionsColumn
                }
            },
        },
        methods: {
            filterAction(e, query) {
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            }
        }
    }
</script>

<style>

</style>